module.exports = __webpack_public_path__ + "img/155.6bc7aef2.jpg";